//// Quant selectors
(function($, window, undefined) {

  var defaults = {
    onChange: null,
  }

  function qntSel(element, settings) {
    this.element = $(element)
    this.settings = $.extend({}, defaults, settings)
    this.init()
  }

  qntSel.prototype = {
  
    init: function() {      
      var _this = this
      this.minus = this.element.find('span').first(),
      this.plus = this.element.find('span').last(),
      this.input = this.element.find('input')   
      this.min = 0
      this.max = Math.pow(10, 1000) 
      
      if(this.input.prop('min')){
        this.min = this.input.prop('min')
      }
      
      if(this.input.prop('max')){
        this.max = this.input.prop('max')
      }
      
     
      //bind handlers
      this.minus.on('click', function(e) {
        _this.updateValue('minus')
      })
      this.plus.on('click', function(e) {
        _this.updateValue('plus')
      }) 
      this.input.on('change', function(e) {
        //change hanlder
      }) 
    },
    
    updateValue:function(math){
      var a = parseInt(this.input.val()),
          p1 = a + 1,
          m1 = a - 1
                 
      if(math == 'plus' && p1 <= this.max){
        this.input.val(p1).trigger('change')
      }
      if(math == 'minus' && m1 >= this.min){
        this.input.val(m1).trigger('change')
      }
    },
    

  }

  $.fn.qntSel = function(settings) {
    return this.each(function () {
      $.data(this, 'qntSel', new qntSel(this, settings))
    })
  }

}(jQuery, window));